import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik, Form, ErrorMessage, Field } from "formik";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import SubTituloResMini from "../../../atoms/subTitles/SubTituloResMini";
import { updatePasswd } from "../../../services/UsuarioSihrusService";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import { isUser, logout } from "../../../services/LoginService";
import { useNavigate } from "react-router-dom";

registerLocale("es", es);

const CambioPasswd = (object) => {
  const navigate = useNavigate()
  const [token] = useLocalStorage("token", "");
  const [loading, setLoading] = useState(false);
  const [user] = useLocalStorage('user', '');
  // const [mensaje, setMensaje] = useState();
  const [showConfirm] = useState(false);
  const [data,setData]=useState()


  //TODO:Al actualizar la contraseña deberia cerrar sesión por que al actualizar seria una
  //opcion que iniciara sesion de nuevo

  const actualizaPasswd = (valores) => {
    updatePasswd(valores.passNew, valores.passNewValid).then((data) => {
      logout()
      navigate("/") //TODO:logout deberia dejar salir de una vez //COMPROBAR
    });
  };

  useEffect(() => {
    setLoading(true);
  }, [token]);

  function modalCambioPasswd() {
    return (
      <Modal
        className={`infModal fechas ${showConfirm ? "opacity-0" : "opacity-100"
          } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Cambio de contraseña"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Cambio de contraseña</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 p-3">
            <Formik
              initialValues={{
                usu: user?.username,
                passActual: "",
                passNew: "",
                passNewValid: "",
              }}
              validate={(valores) => {
                const errores = {};
                const usuarioValidacion = { username: valores.usu, password: valores.passActual }
                isUser(usuarioValidacion).then((data) => {
                  setData(data) 
                })
                if (!data){
                  errores.passActual = "Contraseña Incorrecta";
                }
                if (valores.passNew == null || valores.passNew === "") {
                  errores.passNew = "No debe dejar vacio este campo";
                }
                if (valores.passNewValid == null || valores.passNewValid === "") {
                  errores.passNewValid = "No debe dejar vacio este campo";
                }
                if (valores.passNewValid !== valores.passNew) {
                  errores.passNewValid = "Las contraseñas no coinciden";
                }
                if (valores.passActual === valores.passNew && valores.passActual === valores.passNewValid) {
                  errores.passNewValid = "Las contraseñas introducidas no pueden ser igual a la ya existente";
                }

                return errores;
              }}
              onSubmit={(valores) => {
                actualizaPasswd(valores)
              }}
            >
              {({ errors, values }) => (
                <>
                  <Form>
                    <div className="container">
                      <div className="row">
                        {loading ? (
                          <>
                            <div className="row col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                              <label htmlFor="usu">
                                <SubTituloResMini nombre="Nombre de Usuario"></SubTituloResMini>
                              </label>
                              <Field
                                type="text"
                                id="usu"
                                name="usu"
                                className="form-control"
                                placeholder="Usuario"
                                disabled
                              />
                            </div>

                          
                            <div className="row  col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label htmlFor="passActual">
                                <SubTituloResMini nombre="Introduce tu contraseña actual"></SubTituloResMini>
                              </label>
                              <Field
                                type="password"
                                id="passActual"
                                name="passActual"
                                className="form-control"
                                placeholder="Contraseña Actual"
                              />
                              <ErrorMessage
                                name="passActual"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.passActual}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                              <label htmlFor="passNew">
                                <SubTituloResMini nombre="Nueva Contraseña"></SubTituloResMini>
                              </label>
                              <Field
                                type="password"
                                id="passNew"
                                name="passNew"
                                className="form-control"
                                placeholder="Nueva Contraseña"
                              />
                              <ErrorMessage
                                name="passNew"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.passNew}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                              <label htmlFor="passNewValid">
                                <SubTituloResMini nombre="Repetir nueva Contraseña"></SubTituloResMini>
                              </label>
                              <Field
                                type="password"
                                id="passNewValid"
                                name="passNewValid"
                                className="form-control"
                                placeholder="Nueva Contraseña"
                              />
                              <ErrorMessage
                                name="passNewValid"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.passNewValid}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row justify-content-center pt-4">
                              <div className="col align-self-end col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                                <button
                                  type="submit"
                                  className="btn"
                                  id="btnCambioPasswd"
                                >
                                  Cambiar
                                </button>
                              </div>
                            </div>
                          </>
                        ) : // <>
                          //     <span>
                          //         {mensaje === undefined ? <SpinnerCircle /> : null}
                          //     </span>
                          //     <div className="error rojo fs-4 pt-2">
                          //         {mensaje !== undefined ? mensaje : null}
                          //     </div>
                          //     {mensaje !== undefined ? (
                          //         <>
                          //             <div className="row justify-content-center pt-3">
                          //                 <Button
                          //                     id="btnCerrarConsultaIRPF"
                          //                     clases="btn-card"
                          //                     nombre="Cerrar"
                          //                     tipo="button"
                          //                     funcion={() => {
                          //                         object.handleClose();
                          //                     }}
                          //                 />
                          //             </div>
                          //         </>
                          //     ) : null}
                          // </>
                          null //TODO: Cuando recoja los datos del back descomentar esta parte y usarla
                        }
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalCambioPasswd()}</>;
};

export default memo(CambioPasswd);
